# GraphQL query to get all the emails for a given stage

#import "../fragments/goal-field.graphql"

query GetGoalFields($entityType: String!, $isGoalable: Boolean) {
    entityFields(entityType: $entityType, isGoalable: $isGoalable) {
        ...GoalField
    }
}
